// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-color-box {
  width: 12px;
  height: 12px;
  margin-right: 5px;
  display: inline-block;
}

ul.chart-legend {
  margin-left: 20px;
  list-style-type: none;
}

ul.chart-legend li {
  margin-right: 10px;
  display: inline;
}

ul.chart-legend li:first-child {
  font-weight: bold;
}

select.shaper {
  color: #000;
  background: #a3c2d4 !important;
}

option:not(:checked) {
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/SnapshotManagement/BandwidthChart/BandwidthChart.css","webpack://./services/frontend/app/pages/SnapshotManagement/BandwidthChart/BandwidthChart.css"],"names":[],"mappings":"AADA;ECEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".legend-color-box {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin-right: 5px;\n}\n\nul.chart-legend {\n  margin-left: 20px;\n  list-style-type: none;\n}\n\nul.chart-legend li {\n  display: inline;\n  margin-right: 10px;\n}\n\nul.chart-legend li:first-child {\n  font-weight: bold;\n}\n\nselect.shaper {\n  background: #a3c2d4 !important;\n  color: #000;\n}\n\noption:not(:checked) {\n  background-color: #fff;\n}\n",".legend-color-box {\n  width: 12px;\n  height: 12px;\n  margin-right: 5px;\n  display: inline-block;\n}\n\nul.chart-legend {\n  margin-left: 20px;\n  list-style-type: none;\n}\n\nul.chart-legend li {\n  margin-right: 10px;\n  display: inline;\n}\n\nul.chart-legend li:first-child {\n  font-weight: bold;\n}\n\nselect.shaper {\n  color: #000;\n  background: #a3c2d4 !important;\n}\n\noption:not(:checked) {\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
